import * as types from "./mutation_types";

const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const reset = ({ commit }) => {
  commit(types.ROB_UPDATE_RESET);
};

export const update = ({ commit }, values) => {
  commit(types.ROB_UPDATE_SET_ERROR, "");
  commit(types.ROB_UPDATE_TOGGLE_LOADING);
  axios
    .put(URL_BACKEND + "api-rob/rob/update/" + values.id + "/", values.values)
    .then((response) => {
      commit(types.ROB_UPDATE_SET_UPDATED, true);
      commit(types.ROB_UPDATE_TOGGLE_LOADING);
      const index = values.list.findIndex((value) => value.id === values.id);
      if (index > -1) {
        values.list[index].statut = response.data.statut;
      }
    })
    .catch((e) => {
      commit(types.ROB_UPDATE_TOGGLE_LOADING);
      commit(types.ROB_UPDATE_SET_ERROR, e.message);
    });
};
